/* global window */

export interface TaskpaneConfig {
  apiBaseUrl: string;
  appBaseUrl: string;
  isProduction: boolean;
  isLocalhost: boolean;
}

export function getTaskpaneConfig(): TaskpaneConfig {
  const appBaseUrl = window.location.origin;
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
  const isProduction = !isLocalhost;

  return {
    apiBaseUrl: isLocalhost ? "http://localhost:8787" : "",
    appBaseUrl,
    isProduction,
    isLocalhost,
  };
}

export function buildApiUrl(path: string): string {
  const config = getTaskpaneConfig();
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${config.apiBaseUrl}${normalizedPath}`;
}
